import { alpha } from '@mui/material';
import { Components, Theme } from '@mui/material/styles';

declare module '@mui/material/Radio' {
  interface RadioPropsSizeOverrides {
    large: true;
  }
}

export const muiRadioOverride: Components<Theme>['MuiRadio'] = {
  styleOverrides: {
    root: ({ theme, ownerState }) => ({
      padding: theme.spacing(2),
      marginRight: ownerState.checked ? theme.spacing(2) : 0,
      '&:hover': {
        backgroundColor: 'transparent',
      },
    }),
    colorPrimary: ({ theme }) => ({
      color: theme.vars.palette.grey[800],
      '&.Mui-checked': {
        color: theme.vars.palette.primary[500],
      },
      '& span:has(svg)': {
        '&:focus-visible': {
          outlineColor: theme.vars.palette.primary.light,
          outlineWidth: 2,
          outlineOffset: 2,
          borderRadius: '50%',
        },
      },
      '&.Mui-disabled': {
        color: theme.vars.palette.grey[500],
      },
      '&:hover': {
        backgroundColor: theme.vars.palette.primary.light,
      },
    }),
    colorSecondary: ({ theme }) => ({
      color: theme.vars.palette.common.black,
      '&.Mui-checked': {
        color: theme.vars.palette.common.black,
      },
      '& span:has(svg)': {
        '&:focus-visible': {
          outlineColor: theme.vars.palette.grey[500],
          outlineWidth: 2,
          outlineOffset: 2,
          borderRadius: '50%',
        },
      },
      '&.Mui-disabled': {
        color: theme.vars.palette.grey[500],
      },
      '&:hover': {
        backgroundColor: alpha(theme.palette.grey[400], 0.2),
      },
    }),
  },
};
